import React from "react";
export function LockIcon({ title = "Read-only" }) {
  return (
    <span className="lock-icon" aria-hidden="true" title={title}>
      {/* 12x12 padlock */}
      <svg width="12" height="12" viewBox="0 0 24 24">
        <path
          d="M17 9h-1V7a4 4 0 10-8 0v2H7a2 2 0 00-2 2v7a2 2 0 002 2h10a2 2 0 002-2v-7a2 2 0 00-2-2zm-7-2a2 2 0 114 0v2h-4V7zm7 11H7v-7h10v7z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
